import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { RulesClientService } from "../../../../../../services/rules/rules-client.service";
import { RuleCollectionAiPromptRequest } from "../../../../../../models/rules/rules.models";

@autoinject
@transient()
export class RuleCollectionAiPromptDialog {

    businessUnitId?: number;
    ruleCollectionId: number;
    ruleCollectionPrompt: string = "";

    constructor(private rulesClientService: RulesClientService, private dialogClientSerivice: DialogClientService, 
        private notificationClientSerivice: NotificationClientService){}

    activate(params: { ruleCollectionId: number, businessUnitId?:number }) {
        this.ruleCollectionId = params.ruleCollectionId;
        this.businessUnitId = params.businessUnitId;
    }

    async attached () {

        //Get rule collection AI prompt
        const response = await this.rulesClientService.getRuleCollectionAiPrompt(this.ruleCollectionId, this.businessUnitId);
        this.ruleCollectionId = response.ruleCollectionId;
        this.ruleCollectionPrompt = response.ruleCollectionPrompt;
    }

    //Submit
    public async submit() {
        try {
            const request: RuleCollectionAiPromptRequest = {
                businessUnitId: this.businessUnitId,
                ruleCollectionId: this.ruleCollectionId,
                ruleCollectionPrompt: this.ruleCollectionPrompt
            }
            await this.rulesClientService.saveRuleCollectionAiPrompt(request);
            this.dialogClientSerivice.hide();
            this.notificationClientSerivice.show("Success", "Rule Collection's AI prompt successuflly saved.", NotificationType.Success);
        }
        catch (error) {
            this.notificationClientSerivice.show("Failed", "An error occurt while trying to save.", NotificationType.Error);
        }
    }

    //Close dialog
    public close() {
        this.dialogClientSerivice.hide();
    }
}